module.exports = __webpack_public_path__ + "media/images/icons/flags/CH-1f88d2bf8b964610cd3df6dcdf600fc3.svg";